import {Component} from "../../../gvf/js/component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../../cp/js/utils-service";

export class ProductConfigSummary extends Component{
    ready(){
        super.ready();
        this.$detailForm = this.findMember("main-form");

        this.$form = this.$root.closest(".js-mod-product-config").find(".js-form");

        this.findMember("add-cart").click(
            (ev)=>{
                ev.preventDefault();

                function disabledButton(){
                    const button = ev.currentTarget;
                    button.disabled = true;
                    button.style.opacity = 0.5;
                    button.style.cursor = "not-allowed";
                    return button;
                }

                this.$form.checkRestrictions().then(
                    (isOk)=>{
                        const button = disabledButton();
                        if(isOk){
                            $(".js-form-field-cut-on-plan__element-to-capture").find(".grid-stack-item-content").removeClass("is-selected");
                            let captureElement = document.querySelector(".js-form-field-cut-on-plan__element-to-capture");
                            let params = {is_cut_field: !!captureElement};
                            GvfService.endpoint(
                                "/web/web/add-confirm-to-cart",
                                {responseAttributes: params}
                            ).then(
                                (resp)=>{
                                    button.style.opacity = 1;
                                    var $popup = $(resp.popupHtml);
                                    $("body").append($popup);
                                    $popup.fadeIn();
                                    $popup.find(".js-popup-confirm__ok").click(
                                        (ev)=>{
                                            ev.preventDefault();
                                            $popup.fadeOut();
                                            window.location = window.location.href.split("?")[0];
                                        }
                                    );
                                    $popup.find(".js-popup-confirm__close").click(
                                        (ev)=>{
                                            ev.preventDefault();
                                            $popup.fadeOut();
                                            window.location = window.location.href.split("?")[0];
                                        }
                                    );
                                }
                            ).catch(UtilsService.alertEndpointResponse);
                        }
                    }
                );

            }
        );

        this.findMember("add-budget-to-cart").click(
            (ev)=>{
                ev.preventDefault();
                this.$form.checkRestrictions().then(
                    (isOk)=>{
                        if(isOk){
                            $(".js-form-field-cut-on-plan__element-to-capture").find(".grid-stack-item-content").removeClass("is-selected");
                            let captureElement = document.querySelector(".js-form-field-cut-on-plan__element-to-capture");
                            let params = {is_cut_field: !!captureElement};
                            GvfService.endpoint(
                                "/web/web/add-confirm-budget-to-cart",
                                {responseAttributes: params}
                            ).then(
                                (resp)=>{
                                    var $popup = $(resp.popupHtml);
                                    $("body").append($popup);
                                    $popup.fadeIn();
                                    $popup.find(".js-popup-confirm__ok").click(
                                        (ev)=>{
                                            ev.preventDefault();
                                            $popup.fadeOut();
                                            window.location = window.location.href.split("?")[0];
                                        }
                                    );
                                    $popup.find(".js-popup-confirm__close").click(
                                        (ev)=>{
                                            ev.preventDefault();
                                            $popup.fadeOut();
                                            window.location = window.location.href.split("?")[0];
                                        }
                                    );
                                }
                            ).catch(UtilsService.alertEndpointResponse);
                        }

                    }
                );
            }
        );

        this.findMember("add-lead").click(
            (ev)=>{
                ev.preventDefault();
                this.$form.checkRestrictions().then(
                    (isOk)=>{
                        if(isOk){
                            $(".js-form-field-cut-on-plan__element-to-capture").find(".grid-stack-item-content").removeClass("is-selected");
                            let captureElement = document.querySelector(".js-form-field-cut-on-plan__element-to-capture");
                            let params = {is_cut_field: !!captureElement};
                            GvfService.endpoint(
                                "/web/web/add-lead",
                                {responseAttributes: params}
                            ).then(
                                (resp)=>{
                                    if(resp.url){
                                        window.location=resp.url;
                                    }
                                }
                            ).catch(UtilsService.alertEndpointResponse);
                        }
                    }
                );
            }
        );

        this.findMember("remove-cart").click(
            ()=>{
                GvfService.endpoint(
                    "/web/web/cancel-current-product",
                    {}
                ).then(
                    (resp)=>{
                        window.location = resp.url;
                    }
                );
            }
        );
        this.findMember("download-product").click(
            ()=>{
                this.$form.checkRestrictions().then(
                    (isOk)=>{
                        this.$root.trigger("cart:quantityUpdated");
                        if(isOk){
                            GvfService.endpoint(
                                "/web/web/download-product",
                                {}
                            ).then(
                                (resp)=>{
                                    window.location = resp;
                                }
                            );
                        }
                    }
                );

            }
        );

        this.$root.find("[name=quantity]").on(
            "keypress change",
            ()=>{
                this.$root.trigger("cart:quantityUpdated");
            }
        );
    }
}
